import styles from "./SWPCalculator.module.css";
import pdfStyles from "./PDF/SWP_PDFCalculator.module.css";
import {
  ComposedChart,
  Area,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';
import Header from "./PDF/Header";
import Footer from "./PDF/Footer"

const formatInteger = value => Math.round(value).toLocaleString('en-IN');

const ResultCard = ({results,variant}) => { 
  const chartData = results
  ? results.map(row => ({
    year: row.year,
    runningResidual: row.totalResidual,
    swpAmount: row.swpAmount
  }))
  : [];

  return (
    <>
          {results && (
            <>
              <div className={styles.chartSection}>
                <h2 className={styles.chartTitle}>Output Curve of Running Residual</h2>
                <div className={styles.chartContainer}>
                  <ResponsiveContainer width="100%" height={variant==='pdf'?350:500}>
                    <ComposedChart data={chartData}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="year" />
                      <YAxis
                        type="number"
                        tickCount={10}   // force 10 ticks
                        // scale="linear"
                        // domain={[-80000000, 10000000]} // full range from -8Cr to +1Cr
                        // ticks={[
                        //   10000000,
                        //   0,
                        //   -10000000,
                        //   -20000000,
                        //   -30000000,
                        //   -40000000,
                        //   -50000000,
                        //   -60000000,
                        //   -70000000,
                        //   -80000000
                        // ]}
                        // interval={0}               
                        // allowDataOverflow={true} // prevents Recharts from clipping 1Cr
                        // padding={{ top: 8, bottom: 8 }}            // room so outer ticks aren't clipped
                        // tickMargin={10}                            // space between axis line and labels
                        // minTickGap={0}                
                        tickFormatter={value => `${(value / 10000000).toFixed(0)}Cr`}
                      />
                      <Tooltip formatter={value => formatInteger(value)} />
                      
                      <Area type="monotone" dataKey="runningResidual" fill="#fed7aa" stroke="#fed7aa" name="Running Residual" />
                      <Line type="monotone" dataKey="swpAmount" stroke="#dc2626" strokeWidth={2} dot={{ fill: '#dc2626', r: 4 }} name="SWP Amount / Year" />
                      <Legend/>
                    </ComposedChart>
                  </ResponsiveContainer>
                </div>
              </div>

               {variant === "pdf" && (
                    <>
                    <div
                    style={{
                      height: "4px",
                      backgroundColor: "rgb(185, 28, 28)",
                      marginTop:"13rem",
                      width: "100%",
                    }}
                  />

                    <Footer pageNumber={0} totalPages={0} />
                    <div style={{
                      marginBottom:"5px",
                      width: "100%",
                    }} > &nbsp;</div>
                    <Header /> 

                    <div
                      style={{
                        height: "3px",
                        backgroundColor: "rgb(185, 28, 28)",
                        marginTop:"10px",
                        marginBottom:"1rem",
                        width: "100%",
                      }}
                    />
                    </>

               )}  


              <div className={variant==='pdf'?pdfStyles.tableContainer:styles.tableContainer}>
                <table className={styles.table}>
                  <thead className={styles.tableHeader}>
                    <tr>
                      <th className={variant==='pdf'?pdfStyles.th:styles.th}>Year</th>
                      <th className={variant==='pdf'?pdfStyles.th:styles.th}>Starting Debt Allocation</th>
                      <th className={variant==='pdf'?pdfStyles.th:styles.th}>Starting Equity Allocation</th>
                      <th className={variant==='pdf'?pdfStyles.th:styles.th}>Year End Gross Total</th>
                      <th className={variant==='pdf'?pdfStyles.th:styles.th}>SWP Amount / Year</th>
                      <th className={variant==='pdf'?pdfStyles.th:styles.th}>Residual Debt</th>
                      <th className={variant==='pdf'?pdfStyles.th:styles.th}>Residual Equity</th>
                      <th className={variant==='pdf'?pdfStyles.th:styles.th}>Total Residual</th>
                      <th className={variant==='pdf'?pdfStyles.th:styles.th}>Increment</th>
                    </tr>
                  </thead>
                  <tbody>
                    {(variant === "pdf"
                      ? results.slice(0, 20)
                      : results
                    ).map((row, index) => (
                      <tr key={index} className={index % 2 === 0 ? styles.rowEven : styles.rowOdd}>
                        <td className={`${variant === 'pdf' ? pdfStyles.td : styles.td} ${styles.tdCenter}`}>{row.year}</td>
                        <td className={`${variant === 'pdf' ? pdfStyles.td : styles.td} ${styles.tdRight}`}>
                          {row.startingDebtAllocation < 1 ? '-' : formatInteger(row.startingDebtAllocation)}
                        </td>
                        {/* <td className={`${styles.td} ${styles.tdRight}`}>{formatInteger(row.startingEquityAllocation)}</td> */}
                        <td className={`${variant === 'pdf' ? pdfStyles.td : styles.td} ${styles.tdRight} ${row.startingEquityAllocation < 0 ? styles.negative : ''}`}>
                          {formatInteger(row.startingEquityAllocation)}
                        </td>
                        {/* <td className={`${styles.td} ${styles.tdRight}`}>{formatInteger(row.yearEndGrossTotal)}</td> */}
                        <td className={`${variant === 'pdf' ? pdfStyles.td : styles.td} ${styles.tdRight} ${row.yearEndGrossTotal < 0 ? styles.negative : ''}`}>
                          {formatInteger(row.yearEndGrossTotal)}
                        </td>
                        <td className={`${variant === 'pdf' ? pdfStyles.td : styles.td} ${styles.tdRight}`} style={{ color: 'red' }}>
                          - {formatInteger(Math.abs(row.swpAmount))}
                        </td>
                        <td className={`${variant === 'pdf' ? pdfStyles.td : styles.td} ${styles.tdRight}`}>{formatInteger(row.residualDebt)}</td>
                        {/* <td className={`${styles.td} ${styles.tdRight}`}>{formatInteger(row.residualEquity)}</td> */}
                        <td className={`${variant === 'pdf' ? pdfStyles.td : styles.td} ${styles.tdRight} ${row.residualEquity < 0 ? styles.negative : ''}`}>
                          {formatInteger(row.residualEquity)}
                        </td>
                        {/* <td className={`${styles.td} ${styles.tdRightBold}`}>{formatInteger(row.totalResidual)}</td> */}
                        <td className={`${variant === 'pdf' ? pdfStyles.td : styles.td} ${styles.tdRightBold} ${row.totalResidual < 0 ? styles.negative : ''}`}>
                          {formatInteger(row.totalResidual)}
                        </td>
                        <td className={`${variant === 'pdf' ? pdfStyles.td : styles.td} ${styles.tdRight} ${row.increment < 0 ? styles.negative : ''}`}>
                          {formatInteger(row.increment)}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                                          
                  {variant==='pdf' && (
                    <>
                    <div
                      style={{
                        height: "3px",
                        backgroundColor: "rgb(185, 28, 28)",
                        marginTop:"2rem",
                        width: "100%",
                      }}
                    />
                    <Footer pageNumber={0} totalPages={0} />

                    <div style={{
                      marginBottom:"20px",
                      width: "100%",
                    }} > &nbsp;</div>

                    <Header />
                    
                    <div
                      style={{
                        height: "4px",
                        backgroundColor: "rgb(185, 28, 28)",
                        marginTop:"10px",
                        marginBottom:"1rem",
                        width: "100%",
                      }}
                    />
                    <table className={styles.table}>
                      <thead className={styles.tableHeader}>
                        <tr>
                          <th className={variant==='pdf'?pdfStyles.th:styles.th}>Year</th>
                          <th className={variant==='pdf'?pdfStyles.th:styles.th}>Starting Debt Allocation</th>
                          <th className={variant==='pdf'?pdfStyles.th:styles.th}>Starting Equity Allocation</th>
                          <th className={variant==='pdf'?pdfStyles.th:styles.th}>Year End Gross Total</th>
                          <th className={variant==='pdf'?pdfStyles.th:styles.th}>SWP Amount / Year</th>
                          <th className={variant==='pdf'?pdfStyles.th:styles.th}>Residual Debt</th>
                          <th className={variant==='pdf'?pdfStyles.th:styles.th}>Residual Equity</th>
                          <th className={variant==='pdf'?pdfStyles.th:styles.th}>Total Residual</th>
                          <th className={variant==='pdf'?pdfStyles.th:styles.th}>Increment</th>
                        </tr>
                      </thead>
                      <tbody>
                        {results.slice(20, 30).map((row, index) => (
                          <tr key={index} className={index % 2 === 0 ? styles.rowEven : styles.rowOdd}>
                            <td className={`${variant === 'pdf' ? pdfStyles.td : styles.td} ${styles.tdCenter}`}>{row.year}</td>
                            <td className={`${variant === 'pdf' ? pdfStyles.td : styles.td} ${styles.tdRight}`}>
                              {row.startingDebtAllocation < 1 ? '-' : formatInteger(row.startingDebtAllocation)}
                            </td>
                            {/* <td className={`${styles.td} ${styles.tdRight}`}>{formatInteger(row.startingEquityAllocation)}</td> */}
                            <td className={`${variant === 'pdf' ? pdfStyles.td : styles.td} ${styles.tdRight} ${row.startingEquityAllocation < 0 ? styles.negative : ''}`}>
                              {formatInteger(row.startingEquityAllocation)}
                            </td>
                            {/* <td className={`${styles.td} ${styles.tdRight}`}>{formatInteger(row.yearEndGrossTotal)}</td> */}
                            <td className={`${variant === 'pdf' ? pdfStyles.td : styles.td} ${styles.tdRight} ${row.yearEndGrossTotal < 0 ? styles.negative : ''}`}>
                              {formatInteger(row.yearEndGrossTotal)}
                            </td>
                            <td className={`${variant === 'pdf' ? pdfStyles.td : styles.td} ${styles.tdRight}`} style={{ color: 'red' }}>
                              - {formatInteger(Math.abs(row.swpAmount))}
                            </td>
                            <td className={`${variant === 'pdf' ? pdfStyles.td : styles.td} ${styles.tdRight}`}>{formatInteger(row.residualDebt)}</td>
                            {/* <td className={`${styles.td} ${styles.tdRight}`}>{formatInteger(row.residualEquity)}</td> */}
                            <td className={`${variant === 'pdf' ? pdfStyles.td : styles.td} ${styles.tdRight} ${row.residualEquity < 0 ? styles.negative : ''}`}>
                              {formatInteger(row.residualEquity)}
                            </td>
                            {/* <td className={`${styles.td} ${styles.tdRightBold}`}>{formatInteger(row.totalResidual)}</td> */}
                            <td className={`${variant === 'pdf' ? pdfStyles.td : styles.td} ${styles.tdRightBold} ${row.totalResidual < 0 ? styles.negative : ''}`}>
                              {formatInteger(row.totalResidual)}
                            </td>
                            <td className={`${variant === 'pdf' ? pdfStyles.td : styles.td} ${styles.tdRight} ${row.increment < 0 ? styles.negative : ''}`}>
                              {formatInteger(row.increment)}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
 
                   

                      
                    <div
                      style={{
                        height: "3px",
                        backgroundColor: "rgb(185, 28, 28)",
                        marginTop:"20rem",
                        width: "100%",
                      }}
                    />
                    <Footer pageNumber={0} totalPages={0} />

                    <div style={{
                      marginBottom:"20px",
                      width: "100%",
                    }} > &nbsp;</div>

                    <Header />
                    
                    <div
                      style={{
                        height: "4px",
                        backgroundColor: "rgb(185, 28, 28)",
                        marginTop:"10px",
                        marginBottom:"1rem",
                        width: "100%",
                      }}
                    />
                    <table className={styles.table}>
                      <thead className={styles.tableHeader}>
                        <tr>
                          <th className={variant==='pdf'?pdfStyles.th:styles.th}>Year</th>
                          <th className={variant==='pdf'?pdfStyles.th:styles.th}>Starting Debt Allocation</th>
                          <th className={variant==='pdf'?pdfStyles.th:styles.th}>Starting Equity Allocation</th>
                          <th className={variant==='pdf'?pdfStyles.th:styles.th}>Year End Gross Total</th>
                          <th className={variant==='pdf'?pdfStyles.th:styles.th}>SWP Amount / Year</th>
                          <th className={variant==='pdf'?pdfStyles.th:styles.th}>Residual Debt</th>
                          <th className={variant==='pdf'?pdfStyles.th:styles.th}>Residual Equity</th>
                          <th className={variant==='pdf'?pdfStyles.th:styles.th}>Total Residual</th>
                          <th className={variant==='pdf'?pdfStyles.th:styles.th}>Increment</th>
                        </tr>
                      </thead>
                      <tbody>
                        {results.slice(30).map((row, index) => (
                          <tr key={index} className={index % 2 === 0 ? styles.rowEven : styles.rowOdd}>
                            <td className={`${variant === 'pdf' ? pdfStyles.td : styles.td} ${styles.tdCenter}`}>{row.year}</td>
                            <td className={`${variant === 'pdf' ? pdfStyles.td : styles.td} ${styles.tdRight}`}>
                              {row.startingDebtAllocation < 1 ? '-' : formatInteger(row.startingDebtAllocation)}
                            </td>
                            {/* <td className={`${styles.td} ${styles.tdRight}`}>{formatInteger(row.startingEquityAllocation)}</td> */}
                            <td className={`${variant === 'pdf' ? pdfStyles.td : styles.td} ${styles.tdRight} ${row.startingEquityAllocation < 0 ? styles.negative : ''}`}>
                              {formatInteger(row.startingEquityAllocation)}
                            </td>
                            {/* <td className={`${styles.td} ${styles.tdRight}`}>{formatInteger(row.yearEndGrossTotal)}</td> */}
                            <td className={`${variant === 'pdf' ? pdfStyles.td : styles.td} ${styles.tdRight} ${row.yearEndGrossTotal < 0 ? styles.negative : ''}`}>
                              {formatInteger(row.yearEndGrossTotal)}
                            </td>
                            <td className={`${variant === 'pdf' ? pdfStyles.td : styles.td} ${styles.tdRight}`} style={{ color: 'red' }}>
                              - {formatInteger(Math.abs(row.swpAmount))}
                            </td>
                            <td className={`${variant === 'pdf' ? pdfStyles.td : styles.td} ${styles.tdRight}`}>{formatInteger(row.residualDebt)}</td>
                            {/* <td className={`${styles.td} ${styles.tdRight}`}>{formatInteger(row.residualEquity)}</td> */}
                            <td className={`${variant === 'pdf' ? pdfStyles.td : styles.td} ${styles.tdRight} ${row.residualEquity < 0 ? styles.negative : ''}`}>
                              {formatInteger(row.residualEquity)}
                            </td>
                            {/* <td className={`${styles.td} ${styles.tdRightBold}`}>{formatInteger(row.totalResidual)}</td> */}
                            <td className={`${variant === 'pdf' ? pdfStyles.td : styles.td} ${styles.tdRightBold} ${row.totalResidual < 0 ? styles.negative : ''}`}>
                              {formatInteger(row.totalResidual)}
                            </td>
                            <td className={`${variant === 'pdf' ? pdfStyles.td : styles.td} ${styles.tdRight} ${row.increment < 0 ? styles.negative : ''}`}>
                              {formatInteger(row.increment)}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>












                    </>
                  )}


                  
              </div>
            </>
          )}

    </>
  );
};

export default ResultCard;